import { render, staticRenderFns } from "./administratorAdd.vue?vue&type=template&id=02efa049&scoped=true&"
import script from "./administratorAdd.vue?vue&type=script&lang=js&"
export * from "./administratorAdd.vue?vue&type=script&lang=js&"
import style0 from "./administratorAdd.vue?vue&type=style&index=0&id=02efa049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02efa049",
  null
  
)

export default component.exports